import { render, staticRenderFns } from "./CreateZuschlagsConfiguration.vue?vue&type=template&id=7c54a5ab"
import script from "./CreateZuschlagsConfiguration.vue?vue&type=script&lang=js"
export * from "./CreateZuschlagsConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports